import { useState, useRef, useEffect } from "react"
import { Typography } from "@stardust-ds/react"

import styles from "./index.module.scss"
import EllipsisCardIcon from "../../../assets/icons/EllipsisCardIcon"
import useClickOutside from "../../../hooks/useClickOutside"

function fnGetOptionsContainerWidth(width) {
  return Number(String(width)?.replace("px", ""))
}

function RcmpCardEllipsisOptions(props) {
  const { bIsOpen, aOptions, fnSetBisOpen, position, size, oOptionsPosition } = props

  const containerRef = useRef(null)

  if (!bIsOpen) return null

  const sizeEllipsis = size ? size : 162

  function fnHandleOnClick(e) {
    e.stopPropagation()

    fnSetBisOpen((e) => !e)
  }

  const containerPositionStyles = () => {
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight
    const menuWidth = fnGetOptionsContainerWidth(sizeEllipsis)
    const menuHeight = containerRef.current?.clientHeight

    if (!oOptionsPosition?.left) return null

    let top = Number(oOptionsPosition?.top) + 30
    let left =
      position === "right"
        ? Number(oOptionsPosition?.left)
        : Number(oOptionsPosition?.left) - (menuWidth - 25)

    if (left + menuWidth > windowWidth) {
      left = windowWidth - menuWidth - 10
    }

    if (top + menuHeight > windowHeight) {
      left += 25
      top = windowHeight - menuHeight - 10
    }

    return {
      position: "fixed",
      top: `${top}px`,
      left: `${left}px`,
    }
  }

  const containerStyles = containerPositionStyles()

  if (!containerStyles) return null

  return (
    <div
      ref={containerRef}
      style={{ width: sizeEllipsis, ...containerStyles }}
      className={styles.options}
      onClick={fnHandleOnClick}
    >
      <>
        {aOptions.map((oItem, nIndex) => {
          return (
            <div key={nIndex} className={styles.option} {...oItem}>
              {oItem?.icon}
              <Typography type="p1">{oItem.label}</Typography>
            </div>
          )
        })}
      </>
    </div>
  )
}

export default function RcmpCardEllipsis(props) {
  const {
    aOptions,
    fill,
    position,
    fnSetData,
    oDataItem,
    size,
    bDisabled,
    className,
    bIsExternalCloseCard = false,
  } = props
  const [bIsOpen, fnSetBisOpen] = useState(false)
  const [oOptionsPosition, setOOptionsPosition] = useState({ top: 0, left: 0 })

  const containerRef = useRef(null)
  useClickOutside(containerRef, () => fnSetBisOpen(false))
  const buttonRef = useRef(null)

  useEffect(() => {
    if (!bIsExternalCloseCard) return
    return fnSetBisOpen(() => false)
  }, [bIsExternalCloseCard])

  useEffect(() => {
    if (!bIsOpen || !buttonRef?.current) return

    const buttonRect = buttonRef.current.getBoundingClientRect()
    if (!buttonRect) return

    const { top, left } = buttonRect
    setOOptionsPosition({ top, left })
  }, [bIsOpen, buttonRef])

  if (!aOptions?.length) return null

  const handleOnClick = (e) => {
    if (bDisabled) return

    if (oDataItem) fnSetData(oDataItem)
    e.stopPropagation()
    fnSetBisOpen(!bIsOpen)
  }

  const cIconFill = fill || "#ffffff"
  const cClass = `${styles.ellipsisContainer} ${bDisabled ? styles.disabled : ""}`

  return (
    <div ref={containerRef} className={cClass} id="ellipsisCardIcon">
      <button
        ref={buttonRef}
        type="button"
        className={`${bIsOpen && styles.active} ${styles.ellipsis} ${className || ""}`}
        onClick={handleOnClick}
      >
        <EllipsisCardIcon fill={cIconFill} className={bIsOpen && styles.active} />
      </button>
      <RcmpCardEllipsisOptions
        position={position}
        fnSetBisOpen={fnSetBisOpen}
        bIsOpen={bIsOpen}
        aOptions={aOptions}
        size={size}
        oOptionsPosition={oOptionsPosition}
        oDataItem={oDataItem}
      />
    </div>
  )
}
